import { Lightning } from '@lightningjs/sdk';
import { ScrollList } from '../shared/ScrollList';
import { ActionButton } from '../../pages/detail/actionRowButtons/ActionButton';
import { ListTranslationKeys, RibbonTranslationKeys } from '../../api/models/TranslationKeys';
import { Theme } from '../../config/theme';
import { ClearCmsFilterAction } from '../../Business/cms/actions/ClearCmsFilterAction';
import { CategoryCmsFilterAction } from '../../Business/cms/actions/CategoryCmsFilterAction';
import { YearCmsFilterAction } from '../../Business/cms/actions/YearCmsFilterAction';
import { RatingCmsFilterAction } from '../../Business/cms/actions/RatingCmsFilterAction';
import { RatingButton } from '../shared/RatingButton';

/**
 * @property {CmsFilterData} filterData
 */
export class CmsVodFilterRow extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      color: Theme.Colors.Transparent,
      rect: true,
      Buttons: {
        w: w => w,
        h: h => h,
        type: ScrollList,
        direction: 'row',
      },
    };
  }

  _init() {
    this.patch({
      h: this.data.height(),
      Buttons: {
        x: this.contentOffset,
        w: w => w - this.contentOffset,
      },
    });
    this.filterData = {};
    this._addButtons();
    // this.alpha = this.data.fadeOut ? CmsConstants.Animation.fadeOut : 1;
    this._clearFilter();
  }

  _getFocused() {
    return this.tag('Buttons');
  }

  _addButtons() {
    const backend = this.data.backend;
    const buttonList = this.tag('Buttons');
    buttonList.items.childList.clear();

    if (this.data.filterCategory) {
      this._categoryButton = buttonList.items.childList.a({
        flexItem: { marginLeft: 15 },
        backend,
        type: ActionButton,
        actionHandler: new CategoryCmsFilterAction(
          backend,
          this.data.tags,
          this.filterData,
          this.data.pageProperties,
          val => {
            this._updateFilter(val);
          }
        ),
      });
    }
    if (this.data.filterProductionYear) {
      this._yearButton = buttonList.items.childList.a({
        flexItem: { marginLeft: 15 },
        backend,
        type: ActionButton,
        actionHandler: new YearCmsFilterAction(backend, this.filterData, val => {
          this._updateFilter(val);
        }),
      });
    }
    if (this.data.filterRating) {
      this._ratingButton = buttonList.items.childList.a({
        flexItem: { marginLeft: 15 },
        backend,
        type: RatingButton,
        actionHandler: new RatingCmsFilterAction(backend, this.filterData, val => {
          this._updateFilter(val);
        }),
      });
    }

    this._clearButton = buttonList.items.childList.a({
      flexItem: { marginLeft: 15 },
      backend,
      type: ActionButton,
      actionHandler: new ClearCmsFilterAction(backend, this.filterData, () => {
        this._clearFilter(true);
      }),
      label: backend.translations.forKey(ListTranslationKeys.lists_btn_clearfilters_android_tv),
    });
  }

  /**
   *
   * @param {CmsFilterData} filter
   * @private
   */
  _updateFilter(filter) {
    let hasValue = false;

    if (filter.category && this._categoryButton) {
      hasValue = true;
      this._categoryButton.label = filter.category.text;
    }
    if (filter.rating && this._ratingButton) {
      hasValue = true;
      this._ratingButton.focusIcon = filter.rating.focusIcon;
      this._ratingButton.icon = filter.rating.icon;
    }
    if (filter.year && this._yearButton) {
      hasValue = true;
      this._yearButton.label = filter.year.text;
    }
    this._clearButton.visible = hasValue;
    this.signal('updateFilter', filter);
  }

  _clearFilter(refocus = false) {
    const backend = this.data.backend;
    if (this._categoryButton) {
      this._categoryButton.label = backend.translations.forKey(RibbonTranslationKeys.ribbon_filter_category);
    }
    if (this._ratingButton) {
      this._ratingButton.icon = undefined;
      this._ratingButton.focusIcon = undefined;
      this._ratingButton.label = backend.translations.forKey(RibbonTranslationKeys.ribbon_filter_rating);
    }
    if (this._yearButton) {
      this._yearButton.label = backend.translations.forKey(RibbonTranslationKeys.ribbon_filter_year);
    }
    this._clearButton.visible = false;
    if (refocus) {
      this.tag('Buttons').focusLastVisible();
    }
    this.signal('updateFilter', {});
  }
}
